export const getWalletsTableColumns = (enableBases) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    slots: { customRender: "id" },
    width: 30,
    align: "center",
  },
  {
    dataIndex: "name",
    key: "name",
    slots: { title: "customName", customRender: "name" },
    sorter: (a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    },
    width: 190,
    ellipsis: true,
  },
  {
    key: "entity",
    dataIndex: "entity",
    slots: { title: "customEntity", customRender: "entity" },
    sorter: (a, b) => {
      if (a.entity.name < b.entity.name) return -1;
      if (a.entity.name > b.entity.name) return 1;
      return 0;
    },
    width: 120,
    ellipsis: true,
  },
  {
    title: "Tipo de operación",
    dataIndex: "operation_type",
    key: "typeofdeal",
    slots: { customRender: "typeofdeal" },
    width: 140,
  },
  {
    title: "Tipo de recordatorio",
    dataIndex: "schedule_management_type",
    key: "schedule_management_type",
    width: 140,
    slots: { customRender: "schedule_management_type" },
  },
  ...(enableBases
    ? [
        {
          dataIndex: "num_bases",
          key: "bases",
          width: 100,
          slots: { title: "titleBases", customRender: "bases" },
        },
      ]
    : []),
  {
    title: "N° Contactos",
    dataIndex: "num_clients",
    width: 100,
  },
  {
    title: "N° Productos",
    dataIndex: "num_products",
    width: 80,
  },
  // {
  //   key: "status",
  //   dataIndex: "status",
  //   slots: { title: "titleStatus", customRender: "status" },
  //   sorter: (a, b) => {
  //     if (a.status < b.status) return -1;
  //     if (a.status > b.status) return 1;
  //     return 0;
  //   },
  //   width: 100,
  // },
  {
    title: "Acciones",
    key: "action",
    slots: { customRender: "actionScoped" },
    width: 90,
    fixed: "right",
  },
];

export const entitiesTableColumns = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
    width: 220,
    // slots: { customRender: "name" },
  },
  {
    title: "Industria",
    dataIndex: "type_industry_name",
    key: "industry",
    width: 200,
  },
  {
    title: "Campañas",
    dataIndex: "num_portfolios",
    key: "typeofoperation",
    // slots: { customRender: "typeofoperation" },
    width: 160,
  },
  {
    title: "Teléfono",
    dataIndex: "phone",
    key: "telefono",
    width: 140,
  },
  {
    title: "Pais",
    dataIndex: "country",
    key: "country",
    width: 140,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 200,
  },
  {
    title: "Acciones",
    key: "actions",
    // slots: { customRender: "actionScoped" },
    width: 120,
    fixed: "right",
  },
];
export const basesTablecolumns = [
  {
    dataIndex: "name",
    key: "name",
    slots: { title: "customBases", customRender: "name" },
    sorter: (a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    },
    width: 220,
  },
  {
    dataIndex: ["portfolio", "name"],
    key: "portfolio.name",
    slots: { title: "customName" },
    width: 210,
    sorter: (a, b) => {
      if (a.portfolio.name < b.portfolio.name) return -1;
      if (a.portfolio.name > b.portfolio.name) return 1;
      return 0;
    },
  },
  {
    key: "entity",
    slots: { title: "customEntity", customRender: "entity" },
    sorter: (a, b) => {
      if (a.entity.name < b.entity.name) return -1;
      if (a.entity.name > b.entity.name) return 1;
      return 0;
    },
    width: 220,
  },

  {
    title: "Nº Contactos",
    dataIndex: "number_clients",
    key: "number_clients",
    width: 120,
  },
  {
    title: "Fecha de inicio",
    dataIndex: "date_start",
    key: "date_start",
    slots: { customRender: "date_start" },
    width: 130,
  },
  {
    title: "Fecha de fin",
    dataIndex: "date_finish",
    key: "date_finish",
    slots: { customRender: "date_finish" },
    width: 130,
  },
  {
    title: "Acciones",
    key: "action",
    slots: { customRender: "actionScoped" },
    width: 130,
    fixed: "right",
  },
];
